import { Feature } from 'ol';
import { GeoJSON } from 'ol/format';
import VectorSource from 'ol/source/Vector';

export const loadGeometryIntoSource = (
  source: VectorSource,
  geojsonFormat: GeoJSON,
  geometryStr: string,
): void => {
  try {
    const feature = JSON.parse(geometryStr);
    const features = geojsonFormat.readFeatures({
      type: 'FeatureCollection',
      features: [feature],
    }) as Feature[];
    source.addFeatures(features);
  } catch {
    // ignore malformed geometry
  }
};
